import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE =
  "حاسبة كثافة السكان - حساب كثافة السكان بناءً على عدد السكان ومساحة المنطقة";
const DESCRIPTION =
  "حاسبة كثافة السكان: احسب عدد الأفراد لكل كيلومتر مربع بدقة! أدخل إجمالي السكان ومساحة المنطقة (بالكم² أو الميل²) لمعرفة الكثافة السكانية - مثالية للبحوث الجغرافية والتخطيط الحضري.";
const KEYWORDS = "كثافة السكان, حساب كثافة السكان, حاسبة كثافة السكان";
const OG_URL = "https://do-calculate.com/calculator/ar/population-density";
function Calculator() {
  const [population, setPopulation] = useState("");
  const [area, setArea] = useState("");
  const [density, setDensity] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!population || !area) {
      setError("الرجاء إدخال عدد السكان ومساحة المنطقة بشكل صحيح");
      setDensity("");
      return;
    }
    const populationValue = parseFloat(population);
    const areaValue = parseFloat(area);
    if (
      isNaN(populationValue) ||
      isNaN(areaValue) ||
      populationValue < 0 ||
      areaValue <= 0
    ) {
      setError("الرجاء إدخال قيم صحيحة وموجبة لعدد السكان ومساحة المنطقة");
      setDensity("");
      return;
    }
    const populationDensity = populationValue / areaValue;
    setDensity(populationDensity.toFixed(2));
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>طريقة حساب كثافة السكان</h2>
                <p>
                  إذا كنت ترغب في معرفة كثافة السكان لمنطقة أو دولة أو مدينة ما،
                  يجب عليك أولاً إحصاء عدد السكان في تلك المنطقة ومعرفة مساحتها.
                  ثم يمكنك حساب كثافة السكان عن طريق قسمة عدد السكان على مساحة
                  المنطقة.
                </p>
                <p>كثافة السكان = (عدد السكان / مساحة المنطقة)</p>
                <p>
                  يمكن استخدام هذه الحاسبة لحساب كثافة السكان بناءً على الأرقام
                  المُدخلة.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">عدد السكان</label>
                      </b>
                      <input
                        type="number"
                        placeholder="عدد السكان"
                        value={population}
                        onChange={(e) => setPopulation(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          مساحة المنطقة (متر مربع)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="مساحة المنطقة"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب كثافة السكان
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {density !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              كثافة السكان: {density} نسمة/م2
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
